import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";

import FacetList from "../components/FacetList.jsx";
import Pager from "../components/Pager.jsx";
import QueryField from "../components/QueryField.jsx";
import ResultSummary from "../components/ResultSummary.jsx";
import SearchCard from "../resultcards/SearchCard.jsx";
import SortToggle from "../components/SortToggle.jsx";
import PerPageSelector from "../components/PerPageSelector.jsx";

export default class Search extends React.Component {
  constructor(props) {
    super(props);
  }

  renderItem = (item, i) => {
    const { loading, wrapperid } = this.props;

    switch(item.type) {
      default:
        return (
          <SearchCard key={i}
            index={i}
            loading={loading}
            {...item} />
        );
    }
  }

  render() {
    const { config, data, handleUpdate, loading } = this.props;
    const { dictionary, id, showResultsSummary, sorters, perPageOptions } = config;
    const { facets, request, results, suggestion, totalResults } = data;
    const { searchBoxLabel, sortLabel, title, perPageLabelBefore, perPageLabelAfter } = dictionary;

    const dateInfo = {
      endDate: request.endDate ? request.endDate : "",
      id: id,
      startDate: request.startDate ? request.startDate : ""
    };

    const queryInfo = {
      label: searchBoxLabel,
      id: id + "query",
      handleUpdate: handleUpdate,
      q: request.q
    };

    const searchClass = classNames("search search--gridded", {
      "is-loading": loading
    });

    return (
      <div className={ searchClass }>
        <div className="visually-hidden" aria-live="polite">{ loading && "Loading" } { !loading && "Loding Complete" }</div>
        <div className="search__header">
          <h1 className="search__title">{ title }</h1>
          <QueryField
            label={ searchBoxLabel }
            id={ id + "-query" }
            handleUpdate = { handleUpdate }
            q={ request.q } />
        </div>
        { facets.length > 0 && <div className="search__facets">
          <FacetList
            dictionary={ dictionary }
            facets={ facets }
            selectedFacets={ request.facet }
            handleUpdate = { handleUpdate }
            dateInfo={ dateInfo }
            queryInfo={ queryInfo }/>
        </div> }
        <div className="search__results">
          { !loading && results.length < 1 && !suggestion && <div className="search__suggestion" aria-live="polite">
            <p>No results for "{ request.q }"</p>
            </div> }
          { suggestion &&  <div className="search__suggestion" aria-live="polite">
            <p>No results for "{ suggestion.originalterm }"</p>
            <p>If you meant to search for <a href={ suggestion.suggesturl }>{ suggestion.suggest }</a>, please see results below</p>
            </div>}
          { results.length > 0 && <div className="search__info">
            { showResultsSummary && <ResultSummary
                dictionary={ dictionary }
                page={ parseInt(request.page) }
                perPage={ parseInt(request.perPage) }
                totalResults={ totalResults } />}
            { sorters && <SortToggle
                handleUpdate = { handleUpdate }
                sortLabel={ sortLabel }
                sorters={ sorters }
                sortBy={ request.sortBy } /> }
          </div> }
          { results.length > 0 && <div className="digest-list">
            <div className="digest-list__list digest-list__list--dividers">
              { results.map((result, i) => this.renderItem(result, i)) }
            </div>
          </div>}
        </div>
        <div className="search__pager-wrapper">
          { results.length > 0 && <Pager
            handleUpdate = { handleUpdate }
            page={ parseInt(request.page) }
            perPage={ parseInt(request.perPage) }
            totalResults={ totalResults } /> }
          { results.length > 0 && <PerPageSelector
              handleUpdate = { handleUpdate }
              perPageLabelBefore={ perPageLabelBefore }
              perPageLabelAfter={ perPageLabelAfter }
              perPageOptions={ perPageOptions }
              perPage={ request.perPage } /> }
        </div>
      </div>
    );
  }
}

const { bool, func, object } = PropTypes;

Search.propTypes= {
  config: object.isRequired,
  data: object.isRequired,
  handleUpdate: func.isRequired,
  loading: bool
};
